import React from 'react';
import { Helmet } from 'react-helmet-async';

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Refund Policy - MilkDairy Farm</title>
      </Helmet>
      <div className="bg-gray-50 min-h-screen py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Refund & Cancellation Policy</h1>
            <p className="text-gray-500">Last updated: {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <div className="w-20 h-1 bg-green-500 mx-auto mt-4"></div>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 space-y-8">
            <div className="bg-red-50 rounded-xl p-6 border-l-4 border-red-500">
              <h2 className="text-xl font-bold text-red-700 mb-2">No Refund Policy on Active Investments</h2>
              <p className="text-gray-700">
                Once an investment is made and verified, the amount cannot be refunded before the maturity date. All investments are subject to a 12-month lock-in period.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Investment Cancellation</h2>
              <p className="text-gray-600 leading-relaxed">
                You may cancel your investment request only if it is still in "Pending" status:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Cancellation allowed only before admin verification</li>
                <li>Once verified, the investment cannot be cancelled</li>
                <li>Cancellation request must be submitted within 24 hours of investment</li>
                <li>Full refund will be processed within 7 business days</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Failed Payment Verification</h2>
              <p className="text-gray-600 leading-relaxed">
                If your payment verification fails due to:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Invalid or unclear payment screenshot</li>
                <li>Mismatched transaction amount or UID</li>
                <li>Duplicate payment requests</li>
              </ul>
              <p className="text-gray-600 mt-3">
                Your investment will be rejected and the amount will be refunded within 7-10 business days.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Maturity Withdrawal</h2>
              <p className="text-gray-600 leading-relaxed">
                Upon reaching the maturity date:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>You can withdraw your full principal + accumulated returns</li>
                <li>Withdrawal requests are processed within 3-5 business days</li>
                <li>No penalties apply for maturity withdrawals</li>
                <li>Funds will be transferred to your registered bank account</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Refund Process</h2>
              <p className="text-gray-600 leading-relaxed">
                Refunds are processed through the original payment method:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Bank transfers will be refunded to the same bank account</li>
                <li>UPI payments will be refunded to the same UPI ID</li>
                <li>Processing time: 7-10 business days</li>
                <li>You will receive email confirmation once refund is initiated</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Contact for Refunds</h2>
              <p className="text-gray-600 leading-relaxed">
                For any refund-related queries, please contact:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Email: <span className="text-green-600">assetsdairyfarm@gmail.com
                </span></li>
                <li>Phone: <span className="text-green-600">+91 88108 42864</span></li>
                <li>Support Hours: Monday to Saturday, 10 AM - 6 PM</li>
              </ul>
            </div>

            <div className="bg-green-50 rounded-xl p-6 border-l-4 border-green-500 text-center">
              <p className="text-gray-700">
                <strong>📌 Note:</strong> All refunds and withdrawals are subject to verification and may take additional time during bank holidays.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;